import { API_PREFIX } from 'shared/api/constants/api-constants'

export const communityKeys = {
  /** `/api` */
  all: () => [API_PREFIX] as const,
  /** `/api/community` */
  communityGeneral: () => [...communityKeys.all(), '/community'] as const,

  /** `/api/community/community/${path}/autocomplete?searchBy=${query}` */
  searchSuggestions: (path: string, topicPath?: string, query?: string) =>
    [
      ...communityKeys.communityGeneral(),
      '/autocomplete',
      { path, topicPath, searchBy: query },
    ] as const,
} as const
